import React from "react";
import { useTranslation } from "react-i18next";

const KeyValueTable = ({ data }) => {
    const { t } = useTranslation();

    return (
        <table className="table key-value-table">
            <tbody>
                {Object.entries(data).map(([key, value], index) => (
                    <tr key={index}>
                        <th>{t(`properties.${key}`)}</th>
                        <td>{value !== null && value !== undefined ? value : "-"}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default KeyValueTable;
